import { Refusal } from '@accounts/transport';

/**
 * What a failed sign-in says, in the person's words.
 *
 * Details the provider refused are "those details did not sign you in", never "your session expired":
 * there was no session. An address another account holds names the ways in (ACC-04); a deleted account
 * says when (ACC-19); a wait says how long.
 */
export function explain(error: unknown, text: (key: string, values?: Record<string, string | number>) => string, date: (value: string) => string): string {
	if (!Refusal.is(error)) return text('error.unexpected');
	if (error.code === 'IDENTITY_MATCHES_ACCOUNT') {
		const methods = ((error.details?.methods as string[] | undefined) ?? []).map(name => text(`identities.provider.${name}`));
		if (!methods.length) return text('signin.matches.short');
		return text('signin.matches', { methods: methods.join(', '), provider: text('identities.provider.another') });
	}
	if (error.code === 'ACCOUNT_ERASED') {
		const at = error.details?.at;
		return typeof at === 'string' ? text('signin.erased.at', { date: date(at) }) : text('signin.erased.short');
	}
	if (error.unauthenticated) return text('signin.refused');
	return text(error.key, error.values);
}
